import { CreatePreparationRequest, PreparationApiAdapter } from '../adapters/PreparationApiAdapter';

export type PreparationType = 'masivo' | 'picking_packing';

export interface CreatePreparationParams {
    orderIds: number[];
    preparationType: PreparationType;
}

export class PreparationService {
    constructor(private apiAdapter: PreparationApiAdapter) { }

    async createPreparation(params: CreatePreparationParams): Promise<{ success: boolean; message?: string; preparationId?: number }> {
        // Validaciones de negocio
        if (!params.orderIds || params.orderIds.length === 0) {
            throw new Error('Debe seleccionar al menos un pedido para preparar');
        }

        if (params.orderIds.some(id => !id || id <= 0)) {
            throw new Error('Los IDs de pedidos deben ser válidos');
        }

        if (!params.preparationType) {
            throw new Error('Debe seleccionar un tipo de preparación');
        }

        // Mapear tipo de preparación a número según especificación
        const preparationTypeMap: Record<PreparationType, number> = {
            'masivo': 1,
            'picking_packing': 3
        };

        const preparationTypeId = preparationTypeMap[params.preparationType];

        if (!preparationTypeId) {
            throw new Error('Tipo de preparación no válido');
        }

        // Crear request para el API
        const request: CreatePreparationRequest = {
            ids: params.orderIds,
            preparation_type: preparationTypeId
        };

        try {
            const response = await this.apiAdapter.createPreparation(request);

            // La API puede devolver success: undefined, pero si hay preparationId es exitoso
            const isSuccess = response.success === true || (response.preparation_id && response.preparation_id > 0);

            return {
                success: isSuccess || false,
                message: response.message,
                preparationId: response.preparation_id
            };
        } catch (error) {
            console.error('Error creating preparation:', error);

            // Manejar errores específicos del API
            if (error instanceof Error) {
                throw new Error(`Error al crear la preparación: ${error.message}`);
            }

            throw new Error('Error inesperado al crear la preparación');
        }
    }
} 